module.exports = __webpack_public_path__ + "static/media/crees5.16091563.JPG";